/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
import React__default from 'react';
import { Grid, Stack, Typography, Button } from '@mui/material';
import { Refresh } from '@mui/icons-material/index.js';
import { ErrorBoundary } from '../../node_modules/react-error-boundary/dist/react-error-boundary.esm.js';

var ErrorFallback = function (_a) {
    var error = _a.error, resetErrorBoundary = _a.resetErrorBoundary;
    return (React__default.createElement(Grid, { container: true, spacing: 0, direction: "column", alignItems: "center", justifyContent: "center", style: { minHeight: '80vh' } },
        React__default.createElement(Grid, { item: true, xs: 'auto' },
            React__default.createElement(Stack, { direction: "column", spacing: 2, alignItems: "center" },
                React__default.createElement(Typography, { variant: "h6" }, "Something went wrong!"),
                React__default.createElement(Typography, null, error.message),
                React__default.createElement(Button, { variant: "contained", size: "small", startIcon: React__default.createElement(Refresh, null), onClick: resetErrorBoundary }, "Refresh page")))));
};
var ErrorHandler = function (props) {
    return (React__default.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback, onReset: function () {
            window.location.reload();
        } }, props.children));
};
var ErrorHandler$1 = ErrorHandler;

export { ErrorHandler$1 as default };
